import * as yup from "yup";

export const validationSchema = yup.object({
  invite: yup.date().required().default(new Date()),
  remind: yup.string().required().default(new Date()),
  template: yup.string().required().default("default"),
});
